import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-image-preview-popup',
  templateUrl: './image-preview-popup.component.html',
  styleUrls: ['./image-preview-popup.component.scss']
})
export class ImagePreviewPopupComponent implements OnInit {
  @Input() documentUrl: string;
  @Input() type: string;
  
  public isPdf: boolean = false;
  public safeUrl: SafeResourceUrl;

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.documentUrl) {
      this.isPdf = this.isPdfFile(this.documentUrl);
      this.safeUrl = this.getSafeUrl(this.documentUrl);
    }
  }

  // Helper method to determine if the file is a PDF
  public isPdfFile(url: string): boolean {
    if (!url) return false;
    return url.toLowerCase().endsWith('.pdf');
  }

  // Helper method to safely display document URLs
  public getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  
  // Helper method to get the file name from URL
  public getFileName(url: string): string {
    if (!url) return '';
    const parts = url.split('/');
    return parts[parts.length - 1];
  }
}